import { getUrlBase } from '../../../utils/general'
import { setPermissions } from './utils'

export const setNavigation = ({ agentPermissions, link }) => {
    if (!link) return { permissionLinkAllowed: false }

    const module = link.split('/')[1]
    const moduleName = getUrlBase(module)

    // both diary types share the same permission token (module.intermediaryDiary.access)
    const permissionModuleMap = {
        intermediaryDiary: 'intermediaryDiary',
        evidenceDiary: 'intermediaryDiary',
        report: 'report',
    }
    const isPermissionControlled = moduleName in permissionModuleMap

    // diaries & reports modules visibility is controlled by permissions,
    // unlike other modules which visibility is controlled by features
    if (isPermissionControlled) {
        const permission = `module.${permissionModuleMap[moduleName]}.access`
        const permissionLinkAllowed = setPermissions(agentPermissions, permission)

        return { permissionLinkAllowed }
    } else {
        return { permissionLinkAllowed: true }
    }
}
